<template>
<div>
  <el-form inline :model="searchForm" :loading="searching">
    <el-form-item label="手机号">
      <el-input placeholder="多个可以用逗号分割" v-model="searchForm.phones">
        <div slot="suffix" class="el-icon-circle-plus" style="color: dodgerblue; margin-top: 0.5rem; padding-right: 0.5rem; font-size: 150%" @click="addMore(0)" />
      </el-input>
    </el-form-item>
    <el-form-item label="姓名">
      <el-input v-model="searchForm.names" placeholder="多个可以用逗号分割">
        <div slot="suffix" class="el-icon-circle-plus" style="color: dodgerblue; margin-top: 0.5rem; padding-right: 0.5rem; font-size: 150%" @click="addMore(1)" />
      </el-input>
    </el-form-item>
    <el-form-item label="联系人手机">
      <el-input v-model="searchForm.contactPhones" placeholder="多个可以用逗号分割">
        <div slot="suffix" class="el-icon-circle-plus" style="color: dodgerblue; margin-top: 0.5rem; padding-right: 0.5rem; font-size: 150%" @click="addMore(2)" />
      </el-input>
    </el-form-item>
    <el-form-item label="联系人姓名">
      <el-input v-model="searchForm.contactNames" placeholder="多个可以用逗号分割">
        <div slot="suffix" class="el-icon-circle-plus" style="color: dodgerblue; margin-top: 0.5rem; padding-right: 0.5rem; font-size: 150%" @click="addMore(3)" />
      </el-input>
    </el-form-item>
    <el-form-item label="备注">
      <el-input v-model="searchForm.remarks" placeholder="多个可以用逗号分割">
        <div slot="suffix" class="el-icon-circle-plus" style="color: dodgerblue; margin-top: 0.5rem; padding-right: 0.5rem; font-size: 150%" @click="addMore(4)" />
      </el-input>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="search" icon="el-icon-search">查询</el-button>
      <el-button @click="reset" icon="el-icon-refresh-right">重置</el-button>
    </el-form-item>
  </el-form>
  <el-row style="display: flex">
    <el-button icon="el-icon-plus" @click="addNewCustomer">新增顾客</el-button>
    <el-button icon="el-icon-delete" @click="deleteItems">批量删除</el-button>
    <el-upload action="/upload/file"
               style="margin-left: 10px;width: 100px"
               :show-file-list="false"
               :on-success="handleFileUploadSuccess">
      <el-button icon="el-icon-document-add">导入</el-button>
    </el-upload>
<!--    <el-button icon="el-icon-document-remove">导出</el-button>-->
  </el-row>
  <el-table :data="list" style="margin-top: 1rem" border
            :header-cell-style="{background:'#eee',color:'black'}"
            max-height="600"
            ref="tableView"
  >
    <el-table-column v-if="list.length > 0" fixed="left"
                     type="selection"
    >
    </el-table-column>
    <el-table-column v-for="(item, index) in listKeyMap"
                     :key="index"
                     :prop="item.key"
                     :label="item.title"
                     :width="item.width"
                     :fixed="item.flex"
                     v-if="item.type !== 3 && item.type !== 2"
                     :type="item.type === 2?'selection':''"
    >
      <template slot-scope="scope">
        <div v-if="item.type === 4" >
        <el-row style="margin-top: 10px" v-for="(actionItem, actionIndex) in scope.row[item.key]" :key="'btn_' + actionIndex">
          <el-tag size="medium" >
            {{actionItem[item.tagValueKey]}}
          </el-tag>
        </el-row>
        </div>
        <div v-else>
          {{scope.row[item.key]}}
        </div>
      </template>
    </el-table-column>
    <el-table-column v-for="(item, index) in listKeyMap"
                     :key="index"
                     :prop="item.key"
                     :label="item.title"
                     :width="item.width"
                     fixed="right"
                     v-if="item.type === 3"
                     :type="item.type === 2?'selection':''"
    >
      <template slot-scope="scope">
        <el-button v-for="(actionItem, actionIndex) in item.actions" :key="'btn_' + actionIndex" size="mini" :type="actionItem.btnType" @click="btnAction(actionItem, scope.row)">
          {{actionItem.title}}
        </el-button>
      </template>
    </el-table-column>
  </el-table>
  <el-pagination style="margin-top: 1rem"
                 :page-size.sync="pageSize"
                 :total.sync="totalCount"
                 :current-page.sync="curPage"
                 @size-change="search"
                 @current-change="search"
                 :page-sizes="[20, 100, 200, 500, 1000]"
                 layout="total, sizes, prev, pager, next, jumper"
  />
  <el-dialog title="批量操作" :visible.sync="showMultipleEditBox">
    <el-card shadow="never" style="flex-wrap: wrap; justify-content: space-around">
      <el-tag v-for="(tag, index) in tags" :key="index" closable style="margin: 0.2rem">
        {{tag}}
      </el-tag>
      <el-input ref="multipleInput" style="margin: 0.2rem; width: 120px" size="small" v-model="multipleEditName" placeholder="新增-回车保存" @keyup.enter.native="change"/>
    </el-card>
    <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="doneAction">确 定</el-button>
        <el-button @click="clearAction">清 除</el-button>
      </span>
  </el-dialog>
  <el-dialog :visible.sync="showEditCustomer" :title="editCustomerTitle" width="50%">
    <add-or-edit-customer :data="customer" @success="customerAddOrEditSuccess" @close="closeAddOrEditCustomer"/>
  </el-dialog>
  <el-dialog :visible.sync="showOrderDialog" width="50%" :title="orderDialogTitle">
    <sku :mode="mode" :customer="customer"/>
  </el-dialog>
</div>
</template>

<script>
import AddOrEditCustomer from './addOrEditCustomer'
import {queryCustomer, deleteByIds, importByUrl} from './customerApi'
import {operationByPath} from '../employee/employeeApi'
import Sku from '../sku/sku'
export default {
  name: 'customer',
  components: {Sku, AddOrEditCustomer},
  data () {
    return {
      searchForm: {
        curPage: 1,
        pageSize: 20,
        phones: '',
        remarks: '',
        contactPhones: '',
        contactNames: '',
        names: ''
      },
      customer: {
        phone: '',
        email: '',
        name: '',
        id: '',
        birthday: null,
        address: '',
        remark: '',
        contacts: []
      },
      searching: false,
      multipleEditBoxType: 0,
      tags: [],
      showMultipleEditBox: false,
      multipleEditName: '',
      showEditCustomer: false,
      editCustomerTitle: '新增顾客',
      curPage: 1,
      totalCount: 0,
      totalPage: 0,
      pageSize: 20,
      list: [],
      listKeyMap: [],
      showOrderDialog: false,
      mode: 'recharge',
      orderDialogTitle: '请选择充值的商品'
    }
  },
  created () {
    this.search()
  },
  methods: {
    search () {
      this.searching = true
      queryCustomer(this.searchForm).then(rsp => {
        this.searching = false
        const {code, message, result} = rsp
        if (code === 0) {
          const { pagination, values } = result
          const { list, curPage, pageSize, totalCount, totalPage } = pagination
          this.curPage = curPage
          this.pageSize = pageSize
          this.totalPage = totalPage
          this.totalCount = totalCount
          this.list = list
          this.listKeyMap = values
        } else {
          this.$message.error(message)
        }
      }).catch(() => {
        this.searching = false
      })
    },
    reset () {
      this.searchForm.phones = ''
      this.searchForm.contacts = ''
      this.searchForm.names = ''
      this.searchForm.contactNames = ''
      this.searchForm.contactPhones = ''
      this.searchForm.remarks = ''
    },
    addMore (type) {
      this.multipleEditBoxType = type
      const key = this.keyForType(type)
      if (key === null) {
        return
      }
      const tempArray = this.searchForm[key].split(',')
      for (let i = tempArray.length - 1; i >= 0; i--) {
        const tempText = tempArray[i].trim()
        if (tempText.length === 0) {
          tempArray.splice(i, 1)
        }
      }
      this.tags = tempArray
      this.showMultipleEditBox = true
      setTimeout(() => {
        this.$refs.multipleInput.focus()
      }, 100)
    },
    keyForType (type) {
      let key = null
      if (type === 0) {
        key = 'phones'
      } else if (type === 1) {
        key = 'names'
      } else if (type === 2) {
        key = 'contactPhones'
      } else if (type === 3) {
        key = 'contactNames'
      } else if (type === 4) {
        key = 'names'
      }
      return key
    },
    doneAction () {
      this.showMultipleEditBox = false
      const text = this.tags.join(',')
      const key = this.keyForType(this.multipleEditBoxType)
      this.searchForm[key] = text
    },
    clearAction () {
      this.tags = []
      this.multipleEditName = ''
    },
    change () {
      const tempName = this.multipleEditName.trim()
      if (tempName.length === 0) {
        return
      }
      if (this.tags.indexOf(tempName) < 0) {
        this.tags.push(tempName)
      }
      this.multipleEditName = ''
      this.$refs.multipleInput.focus()
    },
    addNewCustomer () {
      this.customer = {
        phone: '',
        email: '',
        name: '',
        id: '',
        birthday: null,
        address: '',
        remark: '',
        contacts: []
      }
      this.editCustomerTitle = '新增顾客'
      this.showEditCustomer = true
    },
    customerAddOrEditSuccess () {
      this.showEditCustomer = false
      this.search()
    },
    closeAddOrEditCustomer () {
      this.showEditCustomer = false
    },
    deleteItems () {
      const items = this.$refs.tableView.selection
      if (items === undefined || items.length === 0) {
        this.$message.error('请选择需要删除的数据')
        return
      }
      const deleteAction = () => {
        const ids = []
        for (let i = 0; i < items.length; i++) {
          const tempItem = items[i]
          const {customerId} = tempItem
          ids.push(customerId)
        }
        deleteByIds({ids: ids}).then(rsp => {
          const {code, message} = rsp
          if (code === 0) {
            this.search()
            this.$message.success('操作成功')
          } else {
            this.$message.error(message)
          }
        })
      }
      this.$confirm('确定要删除这些顾客吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(deleteAction).catch(null)
    },
    replaceText (text, item, encode) {
      const keys = Object.keys(item)
      for (let i = 0; i < keys.length; i++) {
        const tempKey = keys[i]
        const matchText = '{' + tempKey + '}'
        const index = text.indexOf(matchText)
        console.log(tempKey + ' ' + index + ' ' + matchText)
        if (index >= 0) {
          if (encode === true) {
            text = text.replace(matchText, encodeURIComponent(item[tempKey]))
          } else {
            text = text.replace(matchText, item[tempKey])
          }
        }
      }
      return text
    },
    handleFileUploadSuccess (rsp) {
      const {code} = rsp
      if (code === 0) {
        // post request
        const { result } = rsp
        const { url } = result
        const data = {}
        data.link = url
        importByUrl(data).then(rsp => {
          const {code} = rsp
          if (code === 0) {
            this.$message.success('导入文件提交成功,稍后请在导入菜单中查看结果')
          } else {
            const {message} = rsp
            this.$message.error(message)
          }
        })
      } else {
        const {message} = rsp
        this.$message.error(message)
      }
    },
    btnAction (action, item) {
      const { type } = action
      if (type === 0) {
        const { code } = action
        if (code === 'edit') {
          this.customer = item
          this.editCustomerTitle = '编辑顾客信息'
          this.showEditCustomer = true
        } else if (code === 'recharge') {
          this.mode = 'recharge'
          this.orderDialogTitle = '请选择充值的商品'
          this.customer = item
          this.showOrderDialog = true
        } else if (code === 'consume') {
          this.mode = 'consume'
          this.orderDialogTitle = '请选择消费的商品'
          this.customer = item
          this.showOrderDialog = true
        }
      } else if (type === 1) {
        const deleteAction = () => {
          let { actionLink } = action
          actionLink = this.replaceText(actionLink, item, true)
          operationByPath(actionLink).then(rsp => {
            const {code, message} = rsp
            if (code === 0) {
              this.search()
              this.$message.success('操作成功')
            } else {
              this.$message.error(message)
            }
          })
        }

        let { alertMsg } = action
        alertMsg = this.replaceText(alertMsg, item, false)
        this.$confirm(alertMsg, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(deleteAction).catch(null)
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/customer/customer.vue